<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure" role="doc-chapter">
<div class="epigraph" role="doc-epigraph">
<p class="epf"><span aria-label="vi" class="page" id="pvi" role="doc-pagebreak"></span>Da mihi castitatem et continentiam, sed noli modo!</p>
<p class="ept">Saint Augustine of Hippo, <i>The Confessions</i></p>
<p class="epf">To acknowledge today that there is failure—not an end, nothing is finished—is to recognize that there is hope. My logic here, don’t forget, is also the logic of Augustine: as long as there is anxiety, there is hope.</p>
<p class="ept">Paul Virilio, <i>The Accident of Art</i></p>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-gunn-0007.vue?4f577f0e